import React from "react";

const SafetyGoggle = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            d="M32.104 10.233C31.203 8.27 29.194 7 26.984 7h-.89v2.28h1.5c.916 0 1.75.527 2.123 1.342l1.718 3.746H34l-1.896-4.135ZM2 16.194h32v2.248H2v-2.248ZM23.38 28h8.07c1.408 0 2.55-1.112 2.55-2.484v-5.243H2v5.243C2 26.888 3.142 28 4.55 28h7.97c.473 0 .937-.122 1.345-.355.408-.232.745-.565.977-.966l1.645-2.843 2.914-.006 1.661 2.855c.232.399.57.731.977.962.407.231.87.353 1.341.353ZM3.885 10.241 2 14.368h2.563l1.71-3.743a2.332 2.332 0 0 1 2.125-1.344h1.51V7h-.9c-2.213 0-4.224 1.272-5.123 3.241Z"
            fill={fill}
        />
    </svg>
);

export default SafetyGoggle;